import styled from 'styled-components';
import {  MetricWidgetBase } from '@components/overview-dashboard/common/mixins';
import breakpoint from 'styled-components-breakpoint';

export const AudienceWidgetWrapper = styled.div`
    ${MetricWidgetBase};
    padding-left: 0px;
    padding-right: 0px;

    ${breakpoint('tablet')`
        width: 100%;
    `};

    ${breakpoint('desktop')`
        width: 32%;
        height: 400px;
    `};

    ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const Metric = styled.div`
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    width: 30%;
`;

export const MetricTotal = styled.div`
    display: flex;
    align-items: flex-end;
    margin: 5px 0px;
`;

export const MetricNumber = styled.div`
    font-size: 30px;
    font-weight: 500;
    line-height: 24px;
    padding-right: 10px;
`;

export const MetricUnit = styled.div`
    font-size: 16px;
    font-weight: 300;
    line-height: 17px;
`;

export const MetricLabel = styled.div`
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
    color: #000000;
    padding-top: 2px;
`;

export const MetricCard = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover { background: #E9F3FD; }
    &:active { background: #E9F3FD; }
    padding: 0px 10px;
    background-color: ${({ selected }: { selected: any }) => selected ? '#E9F3FD' : 'white'};
`;

export const StyledParaHeader = styled.div`
    font-size: 13px;
    font-weight: 400 !important;
`;

export const StyledPara = styled.p`
    font-size: 13px;
    font-weight: 100;
    text-align: left;
`;
